import React from 'react';
import classNames from 'classnames';

import setPreSelectedFilters from '@alumni_v2/utils/setPreSelectedFilters';
import styles from './Breadcrumb.module.scss';

export default function Breadcrumb({ breadcrumbItems, className }) {
  const handleClick = (link) => {
    if (window.location.pathname !== link) {
      window.location.href = link;
      // Clearing the pre-selected filters when any breadcrumb is clicked
      // This isn't ideal and should be updated along with the entire filter
      // page view logic. Had to make this change to support the current logic.
      setPreSelectedFilters([]);
    }
  };

  return (
    <div
      className={classNames(styles.breadcrumbContainer, className)}
    >
      {breadcrumbItems.map(({ title, link }, i) => (
        <div
          key={i}
          className={classNames(
            styles.breadcrumbItem,
            {
              [styles.breadcrumbItemActive]: breadcrumbItems.length - 1 === i,
            },
          )}
          onClick={() => handleClick(link)}
          role="presentation"
        >
          {title}
        </div>
      ))}
    </div>
  );
}
